module.exports = __webpack_public_path__ + "static/media/filter_list_grey.5d8817e7.svg";